import api from './api';

export const openFinanceService = {
  createConnectToken: async () => {
    const response = await api.post('/open-finance/connect-token');
    return response;
  },

  processConnection: async (data) => {
    const response = await api.post('/open-finance/connections', data);
    return response;
  },

  getConnections: async () => {
    const response = await api.get('/open-finance/connections');
    return response;
  },

  getConnection: async (connectionId) => {
    const response = await api.get(`/open-finance/connections/${connectionId}`);
    return response;
  },

  syncAccounts: async (connectionId) => {
    const response = await api.post(`/open-finance/connections/${connectionId}/sync-accounts`);
    return response;
  },

  syncTransactions: async (connectionId, data) => {
    const response = await api.post(`/open-finance/connections/${connectionId}/sync-transactions`, data);
    return response;
  },

  linkAccount: async (connectionId, accountId) => {
    const response = await api.put(`/open-finance/connections/${connectionId}/link`, { accountId });
    return response;
  },

  deleteConnection: async (connectionId) => {
    const response = await api.delete(`/open-finance/connections/${connectionId}`);
    return response;
  },
};

export default openFinanceService;
